var _rect, _rect2, _g, _rect3, _rect4, _rect5, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuture1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 494,
    viewBox: "0 0 208 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 68,
    height: 67,
    rx: 16.5,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 110.5,
    width: 68,
    height: 67,
    rx: 16.5,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_992_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.333 144.267C189.273 144.267 188.255 143.845 187.505 143.095C186.755 142.345 186.333 141.328 186.333 140.267V134",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.667 154.667V130C161.667 129.646 161.807 129.307 162.057 129.057C162.307 128.807 162.646 128.667 163 128.667H178.333C178.687 128.667 179.026 128.807 179.276 129.057C179.526 129.307 179.667 129.646 179.667 130V154.667",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.333 132H165V141.333H176.333V132Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.667 156L179.667 154.667H161.667L159.667 156V159.333H181.667V156Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.667 149.627V148C179.652 147.646 179.712 147.293 179.841 146.963C179.97 146.633 180.166 146.333 180.416 146.083C180.667 145.832 180.966 145.637 181.296 145.508C181.626 145.379 181.979 145.319 182.333 145.333C183.04 145.333 183.719 145.614 184.219 146.114C184.719 146.614 185 147.293 185 148V150C185 150.707 185.281 151.385 185.781 151.886C186.281 152.386 186.959 152.667 187.667 152.667C188.021 152.681 188.374 152.621 188.703 152.492C189.033 152.363 189.333 152.167 189.584 151.917C189.834 151.666 190.03 151.367 190.159 151.037C190.288 150.707 190.347 150.354 190.333 150V141.333C190.333 136 187 133.333 182.333 133.333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 213.5,
    width: 68,
    height: 67,
    rx: 16.5,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 322.5,
    width: 68,
    height: 67,
    rx: 16.5,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 425.5,
    width: 68,
    height: 67,
    rx: 16.5,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_992_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.72 352.92C174.488 348.704 173.985 343.026 173.36 340.68H172C171.374 343.033 170.803 348.704 170.64 352.92H174.72ZM168.6 356.32C165.064 358.625 160.8 361.406 159.08 363.119L159.76 364.479C161.834 363.922 165.812 362.154 169.28 360.399L168.6 356.32ZM176.08 360.399C179.548 362.154 183.559 363.922 185.599 364.479L186.279 363.119C184.559 361.406 180.296 358.625 176.76 356.32L176.08 360.399ZM174.72 371.959L174.04 360.399L174.72 371.959ZM171.32 360.399L170.64 371.959L171.32 360.399ZM172.68 354.28C172.276 354.28 171.882 354.399 171.546 354.623C171.211 354.848 170.949 355.166 170.795 355.539C170.641 355.912 170.6 356.322 170.679 356.718C170.758 357.113 170.952 357.477 171.237 357.762C171.523 358.047 171.886 358.242 172.282 358.32C172.677 358.399 173.088 358.359 173.46 358.204C173.833 358.05 174.152 357.788 174.376 357.453C174.6 357.117 174.72 356.723 174.72 356.32C174.72 355.779 174.505 355.26 174.122 354.877C173.74 354.495 173.221 354.28 172.68 354.28Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.72 347.48H168.599",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.92 351.56H159.76",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.246 343.4H155",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_992_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8033 257.725C32.0034 257.336 31.2871 256.795 30.6945 256.131C30.0626 255.438 29.5634 254.635 29.2217 253.761",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6694 251.619C24.6689 249.996 25.0375 248.393 25.7473 246.933C26.2694 245.855 35.3807 232.205 35.3807 232.205C35.3807 232.205 44.492 245.855 45.0142 246.933C45.7184 248.382 46.0868 249.97 46.092 251.581C46.0972 253.192 45.7391 254.783 45.0444 256.236C44.3496 257.689 43.3361 258.967 42.0793 259.974C40.8224 260.981 39.3546 261.692 37.785 262.054C36.2154 262.415 34.5845 262.418 33.0137 262.062C31.4428 261.706 29.9725 261.001 28.712 259.998C27.4516 258.995 26.4335 257.721 25.7336 256.27C25.0337 254.82 24.67 253.23 24.6694 251.619",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_992_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 50.3333H47",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6667 19.6667C41.6667 19.6667 46.3333 25.9334 46.3333 33.6667C46.3333 41.4001 41.56 47.6667 35.6667 47.6667V47.0001C37 46.3334 40.3333 44.3334 40.3333 38.3334C40.3333 34.2801 39.6667 33.0001 39 31.6667C35.6667 37.6667 30.3333 38.2867 30.3333 43.0001C30.3333 45.0001 31.6667 46.3334 32.3333 47.0001V47.6667C27.6667 47.6667 25 43.6667 25 39.0001C25 31.0001 35.6667 27.6667 35.6667 21.6667V19.6667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_992_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2267 454.667C31.1972 454.046 31.2977 453.426 31.5218 452.846C31.7459 452.267 32.0886 451.741 32.528 451.301C32.9673 450.862 33.4937 450.519 34.0732 450.295C34.6527 450.071 35.2727 449.97 35.8934 450C36.514 449.97 37.134 450.071 37.7135 450.295C38.2931 450.519 38.8194 450.862 39.2588 451.301C39.6981 451.741 40.0408 452.267 40.2649 452.846C40.489 453.426 40.5895 454.046 40.56 454.667",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8936 442V447.333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2266 445.333L31.2266 449.333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8936 454H29.2269",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5601 445.333L40.5601 449.333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8934 454H42.5601",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8936 468.667H21.8936L25.2269 457.333H46.5602L49.8936 468.667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2266 457.333L40.5599 468.667",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5599 457.333L31.2266 468.667",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8936 473.333V468.667",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7798 473.333H41.2265",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8936 462.667H47.8936",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_992_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(159 128)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_992_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.1088,
    height: 32,
    fill: "white",
    transform: "translate(155 340)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_992_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.7615,
    height: 32,
    fill: "white",
    transform: "translate(24 231)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_992_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white",
    transform: "translate(23 19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_992_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.78,
    height: 32,
    fill: "white",
    transform: "translate(21 442)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuture1);
export default __webpack_public_path__ + "static/media/future1.9b3d997e15dd9ec701fdf026e0aa92a0.svg";
export { ForwardRef as ReactComponent };